module.exports = __webpack_public_path__ + "img/xdgslg_float_ico.f6417206.png";